import { useRef, useState } from 'react';

import {
  companyBeneficiariesApi,
  useLazyGetCompanyBeneficiariesSSNQuery
} from '@epi-api/companyBeneficiaries';
import { reduxStore } from 'src/scripts/store-configuration';

export const usePersonalIdMasking = () => {
  const [unmaskedDetails, setUnmaskedDetails] = useState<
    { personId: number; personalId: string } | undefined
  >();

  const [trigger, { isLoading, isError }] =
    useLazyGetCompanyBeneficiariesSSNQuery();

  const paramsCache = useRef<Record<number, number>>({});

  const handleClick = async (personId?: number) => {
    if (unmaskedDetails?.personId === personId || !personId) return;

    const params =
      paramsCache.current[personId] ??
      (paramsCache.current[personId] = personId);

    const cached =
      companyBeneficiariesApi.endpoints.getCompanyBeneficiariesSSN.select(
        params
      )(reduxStore.getState());

    if (cached?.data?.personalId) {
      setUnmaskedDetails({ personId, personalId: cached.data.personalId });
      return;
    }

    const response = await trigger(paramsCache.current[personId])
      .unwrap()
      .catch(() => null);

    if (response?.personalId) {
      setUnmaskedDetails({
        personalId: response.personalId,
        personId
      });
    }
  };

  return {
    unmaskedDetails,
    handleClick,
    isLoading,
    isError
  };
};
